import React, { useState, useEffect } from "react";
import styled from "styled-components";
import { usePatientData } from "../../context/PatientDataContext";

const ModalBackdrop = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background: ${(props) => props.theme.modalOverlay};
  display: ${({ $isOpen }) => ($isOpen ? "flex" : "none")};
  justify-content: center;
  align-items: center;
  z-index: 1000;
`;

const ModalContainer = styled.div`
  background: ${(props) => props.theme.sidebarBackground};
  border-radius: 8px;
  width: 600px;
  height: 530px;
  max-height: 80vh;
  display: flex;
  flex-direction: column;
  box-shadow: 0 5px 15px rgba(0, 0, 0, 0.3);
`;

const ModalHeader = styled.div`
  background-color: ${(props) => props.theme.modalHeader};
  color: white;
  padding: 16px;
  font-size: var(--app-font-size);
  font-weight: bold;
  border-top-left-radius: 8px;
  border-top-right-radius: 8px;
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

const CloseButton = styled.button`
  background: transparent;
  border: none;
  color: white;
  font-size: var(--app-font-size);
  font-weight: bold;
  cursor: pointer;

  &:hover {
    color: #ffdddd;
  }
`;

const FilterBar = styled.div`
  display: flex;
  gap: 8px;
  align-items: center;
  padding: 8px 16px;
  background-color: #f5f5f5;
  border-bottom: 1px solid #ddd;
`;

const ModalScrollable = styled.div`
  flex: 1;
  overflow-y: auto;
`;

const Label = styled.label`
  font-weight: 500;
`;

const Select = styled.select`
  padding: 6px;
  border-radius: 4px;
  border: 1px solid #ccc;
`;

const Input = styled.input`
  flex: 1;
  padding: 6px;
  border-radius: 4px;
  border: 1px solid #ccc;
`;

const ModalContent = styled.div`
  padding: 0 9px 16px 9px;
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

const Table = styled.table`
  width: 100%;
  border-collapse: collapse;
`;

const Thead = styled.thead`
  background-color: #e0e0e0;
`;

const Th = styled.th`
  padding: 8px;
  text-align: left;
  border-bottom: 1px solid #ccc;
  background-color: #e0e0e0;
`;

const Td = styled.td`
  padding: 8px;
  border-bottom: 1px solid #eee;
  cursor: pointer;

  &:hover {
    background-color: #f0f8ff;
  }
`;

const TableWrapper = styled.div`
  max-height: 50vh;
  overflow-y: auto;
`;

const SearchModal = ({ isOpen, onClose, onSelect, patientFilters = {} }) => {
  const [query, setQuery] = useState("");
  const cohortSubgroupActive = patientFilters?.cohortSubgroupActive || "";

  const {
    pacientesModal,
    loadingPacientesModal,
    fetchPacientesModal,
  } = usePatientData();

  useEffect(() => {
    if (isOpen) {
      fetchPacientesModal("", patientFilters);
      setQuery("");
    }
  }, [cohortSubgroupActive, isOpen]);

  const handleSearch = (value) => {
    setQuery(value);
    fetchPacientesModal(value, patientFilters);
  };

  return (
    <ModalBackdrop $isOpen={isOpen} onClick={onClose}>
      <ModalContainer onClick={(e) => e.stopPropagation()}>
        <ModalHeader>
          Buscar Paciente
          <CloseButton onClick={onClose}>&times;</CloseButton>
        </ModalHeader>

        <FilterBar>
          <Input
            type="text"
            placeholder={`Buscar por Identificación o Nombre...`}
            value={query}
            onChange={(e) => handleSearch(e.target.value)}
          />
        </FilterBar>

        <ModalScrollable>
          <ModalContent>
            {loadingPacientesModal ? (
              <p style={{ textAlign: "center" }}>Cargando pacientes...</p>
            ) : (
              <>
                <Table>
                  <Thead>
                    <tr>
                      <Th>Tipo</Th>
                      <Th>Identificación</Th>
                      <Th>Nombre</Th>
                    </tr>
                  </Thead>
                </Table>
                <TableWrapper>
                  <Table>
                    <tbody>
                      {pacientesModal.map((p, i) => (
                        <tr key={i} onClick={() => { onSelect(p); onClose(); }}>
                          <Td>{p.tipo}</Td>
                          <Td>{p.id}</Td>
                          <Td>{p.name}</Td>
                        </tr>
                      ))}
                    </tbody>
                  </Table>
                </TableWrapper>
              </>
            )}
          </ModalContent>
        </ModalScrollable>
      </ModalContainer>
    </ModalBackdrop>
  );
};

export default SearchModal;
